<script setup>
import { ref } from 'vue'
import { getInitials } from '@/utils/strings'
import { getContrastTextColor } from '@/utils/colors'

const props = defineProps({
  employee: {
    type: Object,
  },
  // Vuetify size or 'mico' (18px, e.g. message sender labels)
  size: {
    type: String,
    default: 'small',
  },
  tooltipText: {
    type: String,
    default: null,
  },
  showTooltip: {
    type: Boolean,
    default: true,
  },
  overrideAvatarInitials: {
    type: String,
    default: null,
  },
})

const imageLoadFailed = ref(false)
</script>

<template>
  <VAvatar
    v-if="props.employee"
    :size="props.size === 'mico' ? 18 : props.size"
    :color="props.employee.deleted ? '' : props.employee.color"
    :class="{ 'employee-avatar--deleted': props.employee.deleted }"
  >
    <span
      v-if="!props.employee.imageSource || imageLoadFailed"
      :style="!props.employee.deleted ? `color: ${getContrastTextColor(props.employee?.color)}` : undefined"
      :class="{'xxs-font-size' : props.size === 'x-small' || props.size === 'mico'}"
    >
      {{
        getInitials(
          props.overrideAvatarInitials ||
            props.employee.shortName ||
            props.employee.shortname ||
            props.employee.title ||
            props.employee.fullName ||
            props.employee.name ||
            `${props.employee.firstname || ''} ${props.employee.lastname || ''}`
        )
      }}
    </span>
    <VImg
      v-else
      :src="props.employee.imageSource"
      @error="imageLoadFailed = true"
    />
    <VTooltip
      v-if="props.showTooltip"
      activator="parent"
      location="top"
    >
      {{ props.tooltipText || `${$t('selected_employee')}: ${props.employee.title || props.employee.fullName || props.employee.employeeTitle}` }}
    </VTooltip>
    <slot />
  </VAvatar>
</template>

<!--background: #FFE7E7 !important;-->
<!--color: #A32323 !important;-->
<!--border: 1px solid #FAC9C9 !important;-->
